module.exports = __webpack_public_path__ + "static/media/ug.89d01013.svg";